const LOCAL_DISMISS_KEY = 'gs_motd_dismiss_v1'

/** yyyy-MM-dd in America/New_York — matches server MOTD "calendar day" (EST/EDT). */
function easternDateString (date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date)
}

export function localDismissRecord (): { motdId: string; day: string } | null {
  try {
    const raw = localStorage.getItem(LOCAL_DISMISS_KEY)
    if (!raw) return null
    const [motdId, day] = raw.split('|')
    if (!motdId || !day) return null
    return { motdId, day }
  } catch {
    return null
  }
}

export function isMotdLocallyDismissedToday (motdId: string): boolean {
  const rec = localDismissRecord()
  if (!rec) return false
  const today = easternDateString()
  return rec.motdId === motdId && rec.day === today
}

export function persistMotdLocalDismiss (motdId: string) {
  const today = easternDateString()
  try {
    localStorage.setItem(LOCAL_DISMISS_KEY, `${motdId}|${today}`)
  } catch {
    /* ignore */
  }
}
